/**
 * Cards entièrement cliquables — progressive enhancement.
 *
 * Pour les cards/teasers du site, étend la zone cliquable du lien titre
 * à toute la surface de la card. Sans JS, le lien titre reste fonctionnel.
 *
 * Exclus : .node--type-ressource (cards ressources ont deux liens distincts,
 * PDF + URL externe, qu'on ne peut pas réduire à un seul).
 *
 * UX :
 * - Le clic sur la card navigue vers le href du titre
 * - Le clic sur un lien interne (ex: pill, autre <a>) garde son comportement
 * - Sélection de texte préservée (mousedown != click si l'utilisateur drag)
 * - cursor: pointer ajouté via la classe .is-card-clickable
 * - target="_blank" du titre respecté (ouvre dans un nouvel onglet)
 *
 * RGAA :
 * - Le lien titre reste l'élément focusable principal (pas de tabindex
 *   ajouté sur la card pour éviter de duppliquer la navigation clavier)
 * - Lecteurs d'écran : annoncent le lien titre normalement
 */
(function () {
  'use strict';

  // Sélecteurs des cards à rendre cliquables. À étendre si nouvelles cards
  // sont introduites. Ressources EXCLUES (multi-liens).
  const SELECTORS = [
    '.expo-rubriques__item',           // bandeau Rubriques home
    '.expo-sections .card',            // sous-sections "Pour aller plus loin"
    '.expo-oeuvres article',           // cards œuvres (home + listing)
    '.expo-partenaires article',       // cards partenaires (home + listing)
    '.expo-timeline-page__item',       // étapes chronologiques (page /chronologie)
  ];

  function findTitleLink(card) {
    // Cherche le premier <a href> dans un titre h1-h6 ou .node__title de la card.
    const titleSelectors = ['h1 a', 'h2 a', 'h3 a', 'h4 a', '.node__title a', '.field--name-title a'];
    for (const sel of titleSelectors) {
      const link = card.querySelector(sel);
      if (link && link.getAttribute('href')) {
        return link;
      }
    }
    return null;
  }

  function makeClickable(card) {
    const link = findTitleLink(card);
    if (!link) return;

    // Évite double-init
    if (card.dataset.cardClickable === 'true') return;
    card.dataset.cardClickable = 'true';
    card.classList.add('is-card-clickable');

    let mouseDownX = 0;
    let mouseDownY = 0;

    card.addEventListener('mousedown', function (e) {
      mouseDownX = e.clientX;
      mouseDownY = e.clientY;
    });

    card.addEventListener('click', function (e) {
      // Si l'utilisateur a fait un drag (sélection texte), ne pas naviguer
      const dx = Math.abs(e.clientX - mouseDownX);
      const dy = Math.abs(e.clientY - mouseDownY);
      if (dx > 5 || dy > 5) return;

      // Si le clic est SUR un lien (le titre ou un autre <a>), laisse-le faire
      // son boulot — ne pas déclencher de double navigation.
      if (e.target.closest('a')) return;

      // Sinon, naviguer comme si on avait cliqué sur le lien titre
      const target = link.getAttribute('target');
      const href = link.getAttribute('href');
      if (target === '_blank') {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = href;
      }
    });
  }

  function init() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(makeClickable);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
